import { Controller } from '@hotwired/stimulus'
import { createPopper } from '@popperjs/core'
import { leave, enter } from '@/el-transition'

export default class extends Controller {
  static targets = [
    'menu',
    'button',
    'content',
  ]

  connect() {
    this.popper = createPopper(this.trigger, this.menuTarget, {
      placement: this.placement,
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [8, 8],
          },
        },
      ],
    });

    if (this.isStringTrigger) {
      this.trigger.addEventListener("mouseenter", this.show.bind(this))
      this.trigger.addEventListener("mouseout", this.hide.bind(this))
    }
  }

  show() {
    if (this.contentTarget.classList.contains('hidden')) {
      enter(this.contentTarget, 'dropdown')
    }

    this.popper.update()

    if (this.leaveTimeout) {
      clearTimeout(this.leaveTimeout)
    }
  }

  stopHide() {
    if (this.leaveTimeout) {
      clearTimeout(this.leaveTimeout)
    }
  }

  hide() {
    if (this.leaveTimeout) {
      clearTimeout(this.leaveTimeout)
    }

    this.leaveTimeout = setTimeout(() => {
      leave(this.contentTarget, 'dropdown')
    }, 250);
  }

  get isStringTrigger() {
    if (this.data.has('trigger')) {
      const selector = this.data.get('trigger')
      const element = document.querySelector(selector)

      if (element) {
        return true;
      }
    }

    return false
  }

  get trigger() {
    if (this.hasButtonTarget) {
      return this.buttonTarget
    }

    if (this.data.has('trigger')) {
      const selector = this.data.get('trigger')
      const element = document.querySelector(selector)

      if (element) {
        return element;
      }
    }

    throw new Error('Trigger not found')
  }

  get placement() {
    if (this.data.has('placement')) {
      return this.data.get('placement');
    }
  
    return 'right-start';
  }

  disconnect() {
    this.popper.destroy()

    if (this.isStringTrigger) {
      this.trigger.removeEventListener("mouseenter", this.show.bind(this))
      this.trigger.removeEventListener("mouseout", this.hide.bind(this))}
  }
}